<template>
	<div class="bottom-dialog-container">
		<slot />
	</div>
</template>

<style scoped lang="scss">
@layer hm-components
{
	.bottom-dialog-container
	{
		@include flex(center);
		width:100%;
		padding-inline:var(--gutter-app);
		padding-block-end:var(--spacing-lg);
		pointer-events:none;
		position:fixed;
		inset:auto 0 0 0;
		z-index:9999;

		@include responsive(lg)
		{
			padding-block-end:var(--spacing-3xl);
		}
	}
}
</style>
